import React, {
  useEffect,
  useState,
  useRef,
  useMemo,
  Component,
  ReactNode,
  ErrorInfo,
} from 'react';
import AppLayout from 'containers/layouts/AppLayout';
import { Alert, Container, Grid, Typography, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { amapDescription } from 'content/amapDescription';
import {
  Tooltip, Modal, Box,
} from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { withApollo } from 'hoc/withApollo';
import { useRouter } from 'next/router';
import gql from 'graphql-tag';
import { useMutation, useQuery } from '@apollo/client/react';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkIcon from '@mui/icons-material/Link';
import ContactFormActor from 'containers/forms/ContactFormActor';
import {
  FacebookShareButton,
  TwitterShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
  FacebookIcon as FacebookShareIcon,
  TwitterIcon as TwitterShareIcon,
  TelegramIcon as TelegramShareIcon,
  WhatsappIcon as WhatsappShareIcon,
  EmailIcon as EmailShareIcon,
} from 'react-share';
import _Slider from 'react-slick';
const Slider = (_Slider as any).default || _Slider;
import { useSnackbar } from 'notistack';
import { useCookies } from 'react-cookie';
import Head from 'next/head';
import RichTextContent from 'components/RichTextContent';
import Fab from '@mui/material/Fab';
import EditIcon from '@mui/icons-material/Edit';
import PrintIcon from '@mui/icons-material/Print';
import Image from 'next/image';
import Link from 'components/Link';
import moment from 'moment';
import { RRule } from 'rrule';
import CardSliderActor from 'components/cards/CardSliderActor';
import dynamic from 'next/dynamic';
import { useSessionState } from '../../context/session/session';
import {
  getImageUrl,
  entriesHasElementWithCode,
  urlRectification,
  urlWithHttpsdefault,
  rruleToText,
  buildImageLoaderUrl,
} from '../../utils/utils';
import Favorite from '../../components/Favorite';
import ArticleCard from '../../components/cards/ArticleCard';
import ActorPetitesAnnoncesSection from '../../components/petitesAnnonces/ActorPetitesAnnoncesSection';
// import ActorToPrint from '../../components/print/Actor';
// import ActorGameToPrint from '../../components/print/ActorGame';
import type { GetServerSideProps } from 'next';

const Calendar = dynamic(() => import('../../components/Calendar').then((mod) => mod.default), { ssr: false });
const MapWithNoSSR = dynamic(() => import('../../components/map/Map').then((mod) => mod.default), { ssr: false });
const MarkerWithNoSSR = dynamic(() => import('../../components/map/MarkerEventLocation').then((mod) => mod.default), { ssr: false });
const MarkerActorWithNoSSR = dynamic(() => import('../../components/map/ActorMarker').then((mod) => mod.default), { ssr: false });

// ErrorBoundary for Calendar component to catch rendering errors
interface CalendarErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class CalendarErrorBoundary extends Component<
  { children: ReactNode },
  CalendarErrorBoundaryState
> {
  constructor(props: { children: ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): CalendarErrorBoundaryState {
    console.error('Calendar ErrorBoundary caught error:', error);
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Calendar component error details:', {
      error: error.toString(),
      stack: errorInfo.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Alert severity="error" sx={{ my: 2 }}>
          <strong>Erreur du calendrier:</strong> Le calendrier des événements n'a pas pu se charger.
          {' '}
          {this.state.error && (
            <code style={{ fontSize: '0.8em', display: 'block', marginTop: '8px' }}>
              {this.state.error.message}
            </code>
          )}
        </Alert>
      );
    }

    return this.props.children;
  }
}


type Collection = {
  code: string;
  label: string;
};

type ActorEntry = {
  linkDescription?: string;
  topSEO?: boolean;
  id?: string;
};

type Entry = {
  id: string;
  label: string;
  icon: string;
  enabled?: boolean;
  actorEntries?: ActorEntry;
  collection: Collection;
  parentEntry?: {
    code: string;
    label: string;
    color: string;
    collection: Collection;
    parentEntry?: {
      code: string;
      label: string;
      color: string;
      collection: Collection;
    };
  };
};

type Picture = {
  id: string;
  label: string;
  originalPicturePath: string;
  originalPictureFilename: string;
  position: number;
  logo: boolean;
  main: boolean;
};

type OpeningHourDay = {
  identifier: string;
  day: string;
  selected: boolean;
};

type OpeningHour = {
  days: OpeningHourDay[];
  hours: string[][];
  place: string;
};

type SocialNetwork = {
  id: string;
  type: string;
  url: string;
};

type RelatedActor = {
  id: string;
  name: string;
  address: string;
  lat: number;
  lng: number;
  url: string;
  pictures: Picture[];
};

type Volunteer = {
  id: string;
};

type Referent = {
  id: string;
  surname: string;
  lastname: string;
};

type Actor = {
  id: string;
  name: string;
  address: string;
  lat: number;
  lng: number;
  city: string;
  email: string;
  phone: string;
  website: string;
  description: string;
  updatedAt: string;
  shortDescription: string;
  socialNetwork: string;
  socialNetworks: SocialNetwork[];
  volunteerDescription: string;
  activity: string;
  url: string;
  amapContratLegumes?: string;
  amapAutresContrats?: string;
  fermeModeDistribution?: string;
  volunteerForm?: string;
  volunteerAction?: string;
  favorites: Array<{ id: string }>;
  entries: Entry[];
  volunteers: Volunteer[];
  referents: Referent[];
  isValidated: boolean;
  pictures: Picture[];
  openingHours: OpeningHour[];
  hasVideoVouaaar: boolean;
  memberOf: RelatedActor[];
  partners: RelatedActor[];
  partnerOf: RelatedActor[];
  members: RelatedActor[];
};

type ActorData = {
  actor: Actor;
};

type ArticlePicture = {
  id: string;
  label: string;
  originalPicturePath: string;
  originalPictureFilename: string;
  position: number;
  logo: boolean;
  main: boolean;
};

type Article = {
  id: string;
  label: string;
  shortDescription: string;
  createdAt: string;
  url: string;
  pictures: ArticlePicture[];
};

type ArticlesData = {
  articles: Article[];
};

type EventPicture = {
  id: string;
  label: string;
  originalPicturePath: string;
  originalPictureFilename: string;
  position: number;
};

type Event = {
  id: string;
  label: string;
  shortDescription: string;
  description: string;
  startedAt: string;
  endedAt: string;
  published: boolean;
  dateRule?: string;
  url: string;
  pictures: EventPicture[];
  address: string;
  city: string;
  entries: Entry[];
};

type EventsData = {
  events: Event[];
};

type CalendarEvent = {
  startDate: Date;
  endDate: Date;
  title: string;
  id: string;
  url: string;
  location: string;
  backgroundColor: string;
  duration?: string;
};

type ActorPageProps = {
  initialData: {
    data?: ActorData;
    errors?: Array<{ message: string }>;
  };
};

type StyleParams = {
  topImageSize: string;
  headerDisplay: string;
  hasBannerUrl: boolean;
};

const getSocialNetworkIcon = (type: string) => {
  switch (type) {
    case 'facebook': return <FacebookIcon fontSize="small" />;
    case 'instagram': return <InstagramIcon fontSize="small" />;
    case 'twitter': return <TwitterIcon fontSize="small" />;
    case 'linkedin': return <LinkedInIcon fontSize="small" />;
    case 'youtube': return <YouTubeIcon fontSize="small" />;
    case 'tiktok': return <LinkIcon fontSize="small" />;
    default: return <LinkIcon fontSize="small" />;
  }
};

const getSocialNetworkLabel = (type: string) => {
  switch (type) {
    case 'facebook': return 'Facebook';
    case 'instagram': return 'Instagram';
    case 'twitter': return 'Twitter / X';
    case 'linkedin': return 'LinkedIn';
    case 'youtube': return 'YouTube';
    case 'tiktok': return 'TikTok';
    default: return 'Réseau social';
  }
};

const useStyles = makeStyles<StyleParams>()((theme, { hasBannerUrl }) => ({
  '@media print': {
    fab: {
      display: 'none !important',
    },
  },
  titleContainer: {
    marginTop: theme.spacing(2),
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '24em',
    color: 'white',
    textAlign: 'center',
    padding: '3em',
  },
  align: {
    textAlign: 'center',
  },
  cardInfo: {
    backgroundColor: 'white',
    backgroundPosition: 'right',
    backgroundRepeat: 'no-repeat',
    borderRadius: '0.5em',
    alignItems: 'center',
    boxShadow: '0px 0px 38px -14px rgba(0, 0, 0, 0.46)',
    marginTop: hasBannerUrl ? -53 : 20,
    [theme.breakpoints.up('sm')]: {
      width: '80%',
      padding: '5em',
    },
    [theme.breakpoints.down('md')]: {
      paddingTop: 16,
    },
  },
  infoPratiqueGrid: {
    position: 'relative',
    textAlign: 'center',
    backgroundColor: '#ededf5',
    borderRadius: 5,
    '& > *:first-child': {
      border: 'none',
    },
  },
  printButton: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  description: {
    wordBreak: 'break-word',
    textAlign: 'justify',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '2em',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
      marginTop: 10,
    },
  },
  cardTitle: {
    color: theme.typography.h5.color,
    fontFamily: theme.typography.h5.fontFamily,
    textTransform: 'uppercase',
    textAlign: 'center',
    fontWeight: '400',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.5rem !important',
    },
  },
  actorName: {
    width: '100%',
  },
  h1: {
    fontSize: '3rem',
  },
  cardTitleCategories: {
    color: theme.typography.h5.color,
  },
  infoValue: {
    color: theme.typography.h5.color,
    fontWeight: 700,
    whiteSpace: 'break-spaces',
    overflowWrap: 'break-word',
  },
  infoLabel: {
    color: theme.typography.h5.color,
  },
  game: {
    paddingTop: '13px',
    color: '#D96552',
  },
  printIcon: {
    color: '#D96552',
  },
  border: {
    width: '3em',
    borderColor: '#2C367E',
    borderBottom: 'solid',
    borderBottomColor: '#2C367E',
    color: '#2C367E',
    height: '1em',
    marginBottom: 10,
  },
  iconEntry: {
    height: '20px',
    marginRight: '0.5em',
    marginLeft: '0.5em',
  },
  descriptionInfoLabel: {
    display: 'inline-block',
    fontWeight: 700,
    margin: '0.5em',
  },
  descriptionInfoValue: {
    display: 'inline-block',
  },
  descriptionInfoDiv: {
    display: 'inline-block',
    margin: '0em 1em 0em 1em',
  },
  articleCarroussel: {
    paddingTop: '2em',
  },
  image: {
    height: '200px',
    width: '200px',
    margin: '10px auto',
    '& img': {
      height: '100%!important',
      width: '100%!important',
      objectFit: 'contain',
    },
  },
  slider: {
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      '& .slick-prev': {
        left: 0,
      },
      '& .slick-next': {
        right: 0,
      },
    },
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(0.5),
    top: theme.spacing(0.5),
    color: theme.palette.grey[500],
  },
  paper: {
    position: 'absolute',
    [theme.breakpoints.down('md')]: {
      width: '90%',
    },
    width: '60%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  indication: {
    fontSize: '0.9em',
  },
  infoPratiqueTitle: {
    fontWeight: '900',
    color: '#2C367E',
    width: '100%',
    padding: '1em',
  },
  infoPratiqueItem: {},
  alignLeft: {
    textAlign: 'left',
    padding: '1em 0em 1em 0em',
  },
  alignRight: {
    textAlign: 'right',
    padding: '1em',
  },
  favoriteIcon: {
    color: '#2C367E',
    cursor: 'pointer',
  },
  item: {
    borderWidth: '1px 0px 0px 0px',
    borderStyle: 'dashed',
    borderColor: '#2C367E',
  },
  infoDiv: {
    width: '100%',
  },
  icon: {
    color: '#bd0b3d',
    width: '20px',
  },
  img: {
    padding: '1em',
    maxHeight: '200px',
    width: 'inherit!important',
    cursor: 'pointer',
  },
  imgModal: {
    padding: '1em',
    maxHeight: '50em',
    maxWidth: '100%',
    width: 'inherit!important',
  },
  hide: {
    display: 'none',
  },
  socialNetworkIcon: {
    marginLeft: '5px',
  },
  buttonVolunteer: {
    fontSize: 'inherit',
    margin: '0.5em 0 0.5em 0',
    color: 'white',
    backgroundColor: 'transparent',
    border: '2px solid white',
    borderRadius: '1.5em',
    padding: '0 3em 0 3em',
    minHeight: '2.5em',
    '&:hover': {
      cursor: 'pointer',
      color: '#2C367E',
      backgroundColor: 'white',
      border: '2px solid #2C367E',
      backgroundImage: "url('/arrow-hover.svg')",
    },
    backgroundImage: "url('/arrow.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8em',
    },
    textAlign: 'center',
  },
  buttonVolunteerAction: {
    fontSize: 'inherit',
    margin: '0.5em 0 0.5em 0',
    color: '#2C367E',
    backgroundColor: 'transparent',
    border: '2px solid #2C367E',
    borderRadius: '1.5em',
    padding: '0 3em 0 3em',
    minHeight: '2.5em',
    '&:hover': {
      cursor: 'pointer',
      color: 'white',
      backgroundColor: '#2C367E',
      border: '2px solid #2C367E',
      backgroundImage: "url('/arrow-hover.svg')",
    },
    backgroundImage: "url('/arrow.svg')",
    backgroundRepeat: 'no-repeat',
    backgroundPositionX: '5px',
    [theme.breakpoints.down('md')]: {
      fontSize: '0.8em',
    },
    textAlign: 'center',
  },
  volunteerSection: {
    backgroundColor: '#2b3483',
    paddingBottom: '1em',
    textAlign: 'center',
    borderRadius: '1em',
    marginTop: '1em',
  },
  volunteerTitle: {
    fontWeight: '500',
    color: 'white',
    textTransform: 'uppercase',
    fontSize: '1.5em',
    paddingTop: '2em',
  },
  volunteerDescription: {
    color: 'white',
    fontSize: '1.0em',
    padding: '0 1.2em 0 1.2em',
  },
  fab: {
    position: 'fixed',
    bottom: '40px',
    right: '40px',
    zIndex: '1400',
    backgroundColor: '#2C367E',
    color: 'white',
    '&:hover': {
      color: '#2C367E',
    },
  },
  fabPrint: {
    bottom: '120px',
  },
  map: {
    height: '400px !important',
    width: '100% !important',
  },
  calendar: {
    [theme.breakpoints.down('md')]: {
      width: '100vw',
      marginLeft: -16,
      '& > *:first-child': {
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 5,
      },
    },
    [theme.breakpoints.up('sm')]: {
      width: '100%',
    },
  },
  video: {
    width: '100%',
    maxWidth: '500px',
  },
  mapContainer: {
    height: '100% !important',
  },
}));

const GET_ARTICLES = gql`
query articles ($actorId: String){
  articles(actorId: $actorId) {
    id
    label
    shortDescription
    createdAt
    url
    pictures {
      id
      label
      originalPicturePath
      originalPictureFilename
      position
      logo
      main
    }
  }
}`;

const GET_EVENTS = gql`
query events ($actorId: String){
  events(actorId: $actorId) {
    id
    label
    shortDescription
    description
    startedAt
    endedAt
    published
    dateRule
    url
    pictures {
      id
      label
      originalPicturePath
      originalPictureFilename
      position
    }
    address
    city
    entries {
      label
      icon
      collection {
        code
        label
      }
      parentEntry {
        code
        label
        color
        collection {
          code
          label
        }
      }
    }
  }
}`;

const GET_ACTOR_SSR = `
query actor($url: String) {
  actor(url: $url) {
    id
    name
    address
    lat
    lng
    address
    city
    email
    phone
    website
    description
    updatedAt
    shortDescription
    socialNetwork
    socialNetworks {
      id
      type
      url
    }
    volunteerDescription
    activity
    url
    amapContratLegumes
    amapAutresContrats
    fermeModeDistribution
    volunteerForm
    volunteerAction
    favorites {
      id
    }
    entries {
      id
      label
      icon
      enabled
      actorEntries {
        linkDescription,
        topSEO,
        id,
       }
      collection {
        code
        label
      }
      parentEntry {
        code
        label
        color
        collection {
          code
          label
        }
        parentEntry {
          code
          label
          color
          collection {
            code
            label
          }
        }
      }
    }
    volunteers {
      id
    }
    referents {
      id
      surname
      lastname
    }
    isValidated
    pictures {
      id
      label
      originalPicturePath
      originalPictureFilename
      position
      logo
      main
    }
    openingHours {
      days {
        identifier
        day
        selected
      }
      hours
      place
    }
    hasVideoVouaaar
    memberOf {
      id
      name
      address
      lat
      lng
      url
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
        logo
        main
      }
    }
    partners {
      id
      name
      address
      lat
      lng
      url
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
        logo
        main
      }
    }
    partnerOf {
      id
      name
      address
      lat
      lng
      url
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
        logo
        main
      }
    }
    members {
      id
      name
      address
      lat
      lng
      url
      pictures {
        id
        label
        originalPicturePath
        originalPictureFilename
        position
        logo
        main
      }
    }
  }
}
`;

type SliderArrowProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
};

const SliderArrow = ({ className, style, onClick }: SliderArrowProps) => {
  return (
    <div
      className={className}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
    />
  );
};

type ActorNameProps = StyleParams & { name?: string };

const ActorName = (props: ActorNameProps) => {
  const { name } = props;
  const { classes: styles } = useStyles(props);

  if (!name) return null;

  return (
    <div>
      <Typography variant="h1" className={styles.cardTitle}>
        {name}
      </Typography>
      <div className={styles.border} />
    </div>
  );
};

const Actor = ({ initialData }: ActorPageProps) => {
  const router = useRouter();

  const [currentLocationWindows, setCurrentLocationWindows] = useState<Location | undefined>(undefined);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setCurrentLocationWindows(window.location);
    setIsMounted(true);
  }, []);

  const { url } = router.query;

  // DEBUG MODE: Parse URL parameters to disable features for crash isolation
  const debugDisable = router.isReady ? (router.query.debugDisable as string | undefined) : undefined;
  const debugLog = router.isReady ? (router.query.debugLog as string | undefined) : undefined;

  const disabledFeatures = useMemo(() => {
    if (!debugDisable) return new Set<string>();
    return new Set(String(debugDisable).split(',').map(f => f.trim().toLowerCase()));
  }, [debugDisable]);

  const shouldDisable = (feature: string): boolean => disabledFeatures.has(feature.toLowerCase());

  useEffect(() => {
    if (debugLog === 'true' && typeof window !== 'undefined') {
      console.log('%c🐛 DEBUG MODE ENABLED', 'color: red; font-size: 14px; font-weight: bold;');
      console.log('Disabled features:', Array.from(disabledFeatures));
      console.log('Available features to disable: calendar, share, slider, maps, richtext, contact, articles, memberof, partners');
    }
  }, [debugLog, disabledFeatures]);

  const [eventToRender, setEventToRender] = useState<Event | null>(null);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const [cookies, setCookie, removeCookie] = useCookies();
  const [hasClickVolunteer, setHasClickVolunteer] = useState(false);
  const [openModalSlider, setOpenModalSlider] = useState(false);
  const [openModalRejoindreAMAP, setOpenModalRejoindreAMAP] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const { data } = initialData;
  const actor = data?.actor ?? null;

  const {
    data: dataArticles,
  } = useQuery<ArticlesData>(GET_ARTICLES, {
    variables: {
      actorId: actor ? `${actor.id}` : '',
    },
    skip: !actor,
  });
  const {
    data: dataEvents,
  } = useQuery<EventsData>(GET_EVENTS, {
    variables: {
      actorId: actor ? `${actor.id}` : '',
    },
    skip: !actor,
  });

  const bannerUrl = useMemo(() => {
    if (!actor) return null;
    return (actor.pictures || []).filter((picture) => picture.main)
      .length >= 1
      ? actor.pictures.filter((picture) => picture.main)[0]
        .originalPicturePath
      : null;
  }, [actor]);

  const ADD_ACTOR_VOLUNTEER = gql`
    mutation addActorVolunteer($actorId: Int!, $userId: Int!) {
      addActorVolunteer(actorId: $actorId, userId: $userId)
    }
  `;
  const REMOVE_ACTOR_VOLUNTEER = gql`
    mutation removeActorVolunteer($actorId: Int!, $userId: Int!) {
      removeActorVolunteer(actorId: $actorId, userId: $userId)
    }
  `;

  const user = useSessionState();
  function containUser(list: Array<{ id: string | number }> | undefined): boolean {
    let isContained = false;
    if (user !== null && list !== undefined) {
      list.forEach((element) => {
        if (element.id == (user as { id: string | number }).id) {
          isContained = true;
        }
      });
    }
    return isContained;
  }

  const [favorite, setFavorite] = useState(false);
  useEffect(() => {
    if (actor) setFavorite(containUser(actor.favorites));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actor?.id, user]);

  const handleFavoriteChange = (isFavorite: boolean) => {
    setFavorite(isFavorite);
  };

  const [stylesProps, setStylesProps] = useState<StyleParams>({
    topImageSize: '250px',
    headerDisplay: 'static',
    hasBannerUrl: false,
  });
  useEffect(() => {
    setStylesProps((prev) => ({ ...prev, hasBannerUrl: bannerUrl !== null }));
  }, [bannerUrl]);
  const { classes: styles } = useStyles(stylesProps);

  const [
    addVolunteer,
    { data: volunteerData, loading: volunteerLoading, error: volunteerError },
  ] = useMutation(ADD_ACTOR_VOLUNTEER);
  const [
    removeVolunteer,
    {
      data: removevolunteerData,
      loading: removevolunteerLoading,
      error: removevolunteerError,
    },
  ] = useMutation(REMOVE_ACTOR_VOLUNTEER);

  useEffect(() => {
    if (volunteerData !== undefined) {
      enqueueSnackbar('Demande de bénévole prise en compte', {
        preventDuplicate: true,
      });
      setHasClickVolunteer(true);
    }
  }, [volunteerData]);

  useEffect(() => {
    if (removevolunteerData !== undefined) {
      enqueueSnackbar('Suppression de la demande de bénévole', {
        preventDuplicate: true,
      });
      setHasClickVolunteer(false);
    }
  }, [removevolunteerData]);

  const addVolunteerHandler = () => {
    if (user == null) {
      setCookie('redirect_url', router.asPath, {
        path: `/acteur/${data?.actor?.url}`,
      });
      enqueueSnackbar('Veuillez vous connecter pour devenir bénévole', {
        preventDuplicate: true,
      });
    } else {
      addVolunteer({
        variables: {
          actorId: parseInt(data?.actor?.id ?? ''),
          userId: parseInt((user as { id: string }).id),
        },
      });
    }
  };

  const removeVolunteerHandler = () => {
    removeVolunteer({
      variables: {
        actorId: parseInt(data?.actor?.id ?? ''),
        userId: parseInt((user as { id: string }).id),
      },
    });
  };

  const myLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
    return buildImageLoaderUrl(src, width, quality);
  };

  const getDay = (dayNumber: string) => {
    switch (dayNumber) {
      case '1': return 'Lundi ';
      case '2': return 'Mardi ';
      case '3': return 'Mercredi ';
      case '4': return 'Jeudi ';
      case '5': return 'Vendredi ';
      case '6': return 'Samedi ';
      case '7': return 'Dimanche ';
      default: return '';
    }
  };

  const style = {
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
  const headerRef = React.useRef<HTMLDivElement>();
  const matches = useMediaQuery(theme.breakpoints.down('md'));
  const maxSlideToShowImage = !matches ? 3 : 1;
  const maxSlideToShowArticle = !matches ? 3 : 1;

  const sliderSettings = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SliderArrow />,
    prevArrow: <SliderArrow />,
  };

  function getModalStyle() {
    const top = 50;
    const left = 50;
    return {
      top: `${top}%`,
      left: `${left}%`,
      height: '90%',
      overflow: 'auto',
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const [modalStyle] = React.useState(getModalStyle);
  const bodyModalRejoindreAmap = (
    <div style={modalStyle} className={styles.paper}>
      <IconButton
        aria-label="Close"
        className={styles.closeButton}
        onClick={() => setOpenModalRejoindreAMAP(false)}
        size="large"
      >
        <CloseIcon />
      </IconButton>
      <h2 id="simple-modal-title">Envoyer un message à l'AMAP pour la rejoindre</h2>
      <p className={styles.indication}>Le site vous propose d'envoyer un mail à l'AMAP en votre nom. Votre mail et votre nom ne sont conservés que le temps d'envoyer le mail. Toutes les traces sont ensuite supprimées. Le destinataire reçoit un mail lui expliquant également que ses traces (nom/adresse/mail) ne sont pas conservés. Vous pouvez contacter le Délégué de la Protection des données dpd@ouaaa-transition.fr. Pour toute question, vous pouvez nous contacter <Link href={`/contact`} target="_blank"> en cliquant ici</Link></p>
      <ContactFormActor actorId={data?.actor?.id} />
    </div>
  );

  const actorPictures = data?.actor?.pictures || [];
  const articles = dataArticles?.articles || [];
  const actorPartnersPictures = [
    ...(data?.actor?.partners || []),
    ...(data?.actor?.partnerOf || []),
  ];
  const actorMemberOfPictures = data?.actor?.memberOf || [];
  const actorMembersPictures = data?.actor?.members || [];

  const getSlidesToShow = (length: number, max: number) => {
    if (length <= 0) return 1;
    return length >= max ? max : length;
  };

  const actorWebsiteUrl = actor?.website ? urlWithHttpsdefault(actor.website) : null;
  const actorSocialNetworkUrl = actor?.socialNetwork ? urlWithHttpsdefault(actor.socialNetwork) : null;

  const settingsSliderImage = useMemo(() => {
    return {
      ...sliderSettings,
      slidesToShow: getSlidesToShow(actorPictures.length, maxSlideToShowImage),
    };
  }, [actorPictures.length, sliderSettings, maxSlideToShowImage]);

  const settingsSliderImageActorMemberOf = useMemo(() => {
    return {
      ...sliderSettings,
      slidesToShow: getSlidesToShow(actorMemberOfPictures.length, maxSlideToShowImage),
    };
  }, [actorMemberOfPictures.length, sliderSettings, maxSlideToShowImage]);

  const settingsSliderImageActorPartners = useMemo(() => {
    return {
      ...sliderSettings,
      slidesToShow: getSlidesToShow(actorPartnersPictures.length, maxSlideToShowImage),
    };
  }, [actorPartnersPictures.length, sliderSettings, maxSlideToShowImage]);

  const settingsSliderImageActorMembers = useMemo(() => {
    return {
      ...sliderSettings,
      slidesToShow: getSlidesToShow(actorMembersPictures.length, maxSlideToShowImage),
    };
  }, [actorMembersPictures.length, sliderSettings, maxSlideToShowImage]);

  const settingsSliderImageArticle = useMemo(() => {
    return {
      ...sliderSettings,
      slidesToShow: getSlidesToShow(articles.length, maxSlideToShowArticle),
    };
  }, [articles.length, sliderSettings, maxSlideToShowArticle]);

  function showCategory(entries: Entry[]): string {
    let text = '';
    const nbEntryToShow = 1;
    let nbEntry = 0;
    entries.forEach((entry) => {
      if (
        entry.parentEntry
        && entry.parentEntry.collection
        && entry.parentEntry.collection.code === 'category'
        && nbEntry <= nbEntryToShow
      ) {
        text += `${entry.parentEntry.label} : `;
        text += `${entry.label}  `;
        nbEntry += 1;
      }
    });
    return text;
  }

  function showLaRochelleQuarter(entries: Entry[]): string {
    let text = '';
    entries.forEach((entry) => {
      if (
        entry
        && entry.collection
        && entry.collection.code === 'larochelle_quarter'
      ) {
        text += `, ${entry.label}`;
      }
    });
    return text;
  }

  const parseTimestamp = (value: string | undefined): number | null => {
    const timestamp = Number.parseInt(String(value ?? ''), 10);
    return Number.isFinite(timestamp) ? timestamp : null;
  };

  const logInvalidActorCalendarEvent = (message: string, payload: Record<string, unknown>) => {
    if (process.env.NODE_ENV !== 'production') {
      console.warn(message, payload);
    }
  };

  const getAllEventsFromRecurringEvent = (event: Event): Event[] => {
    const startTimestamp = parseTimestamp(event.startedAt);
    const endTimestamp = parseTimestamp(event.endedAt);

    if (!event.dateRule || startTimestamp === null || endTimestamp === null) {
      logInvalidActorCalendarEvent('Invalid recurring event payload on actor page', {
        eventId: event.id,
        dateRule: event.dateRule,
        startedAt: event.startedAt,
        endedAt: event.endedAt,
      });
      return [];
    }

    try {
      const startEventDate = moment(startTimestamp);
      const endEventDate = moment(endTimestamp);
      const eventDurationInMinutes = Math.max(endEventDate.diff(startEventDate, 'minutes'), 0);
      const rrule = RRule.fromString(`DTSTART:${startEventDate.format('YYYYMMDD[T]HHmmss[Z]')}\nRRULE:${event.dateRule}`);

      return rrule.between(new Date(), moment().add(6, 'month').toDate()).map((date) => {
        const recurringStartDate = moment(date);

        return {
          ...event,
          startedAt: recurringStartDate.valueOf().toString(),
          endedAt: recurringStartDate.clone().add(eventDurationInMinutes, 'minutes').valueOf().toString(),
          duration: rruleToText(rrule as any),
        };
      });
    } catch (error) {
      console.error('Error while expanding recurring actor events', {
        eventId: event.id,
        dateRule: event.dateRule,
        startedAt: event.startedAt,
        endedAt: event.endedAt,
        error,
      });
      return [];
    }
  };

  const events = useMemo<CalendarEvent[]>(() => {
    const initialEvents = (dataEvents?.events || []);
    const recurringEvents = initialEvents.filter((event) => event.dateRule);
    const allRecurringEvents = recurringEvents.reduce<Event[]>((acc, event) => {
      return acc.concat(getAllEventsFromRecurringEvent(event));
    }, []);
    const allEvents = initialEvents.concat(allRecurringEvents);

    return allEvents.reduce<CalendarEvent[]>((acc, evt) => {
      const startTimestamp = parseTimestamp(evt.startedAt);
      const endTimestamp = parseTimestamp(evt.endedAt);

      if (startTimestamp === null || endTimestamp === null) {
        logInvalidActorCalendarEvent('Invalid actor event dates ignored by calendar', {
          eventId: evt.id,
          startedAt: evt.startedAt,
          endedAt: evt.endedAt,
        });
        return acc;
      }

      const startDate = new Date(startTimestamp);
      const endDate = new Date(endTimestamp);

      if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
        logInvalidActorCalendarEvent('Invalid actor event Date objects ignored by calendar', {
          eventId: evt.id,
          startedAt: evt.startedAt,
          endedAt: evt.endedAt,
        });
        return acc;
      }

      acc.push({
        startDate,
        endDate,
        title: evt.label,
        id: evt.id,
        url: evt.url,
        location: evt.city ? [evt.address, evt.city].join(', ') : '',
        backgroundColor:
          evt.entries && evt.entries.length > 0 && evt.entries[0].parentEntry
            ? evt.entries[0].parentEntry.color
            : 'blue',
      });

      return acc;
    }, []);
  }, [dataEvents]);

  const logo = useMemo(() => {
    const logoPictures = actorPictures.filter((picture) => picture.logo);
    return logoPictures.length > 0 ? logoPictures[0] : null;
  }, [actorPictures]);

  const metaImage = useMemo(() => {
    if (bannerUrl) {
      return getImageUrl(bannerUrl);
    }
    if (logo?.originalPicturePath) {
      return getImageUrl(logo.originalPicturePath);
    }
    return null;
  }, [bannerUrl, logo]);

  const handlePrint = () => {
    if (typeof window !== 'undefined') {
      window.print();
    }
  };

  // Guard — all hooks are above, safe to return early here
  if (!actor) {
    return (
      <AppLayout>
        <Container maxWidth="md" sx={{ py: 6 }}>
          <Alert severity="error">
            Impossible de charger cette page acteur pour le moment.
          </Alert>
        </Container>
      </AppLayout>
    );
  }

  return (
    <AppLayout>
      <>
        <Head>
          <title>
            {actor.name}
            {' '}
            {actor.activity}
            {' '}
            -
            {' '}
            {actor.city}
          </title>
          <meta key="og:url" property="og:url" content={`${process.env.NEXT_PUBLIC_BASE_URL}/acteur/${actor.url}`} />
          <meta key="twitter:url" property="twitter:url" content={`${process.env.NEXT_PUBLIC_BASE_URL}/acteur/${actor.url}`} />
          {metaImage && (
            <>
              <meta
                key="og:image"
                property="og:image"
                content={metaImage}
              />
              <meta key="twitter:image" name="twitter:image" content={metaImage} />
            </>
          )}
          {actor.hasVideoVouaaar ? (
            <>
              <script type="application/ld+json">
                {`{
                      "@context": "https://schema.org/",
                      "@type": "VideoObject",
                      "name":  "Vidéo Acteurs à VOUAAAR ! - ${actor.name}",
                      "thumbnailUrl": "https://static.ouaaa-transition.fr/static/video/${actor.id}.jpg",
                      "description": "Présentation de l'acteur ${actor.name} dans le cadre de la série de OUAAA! Acteurs à VOUAAAR ! ",
                      "contentUrl": "https://static.ouaaa-transition.fr/static/video/${actor.id}.mp4",
                      "UploadDate": "${moment(parseInt(actor.updatedAt)).format()}"
                    }`
                }
              </script>
            </>
          ) : null}
          <meta key="og:title" property="og:title" content={actor.name} />
          <meta key="og:description" property="og:description" content={actor.shortDescription} />
          <meta key="twitter:title" name="twitter:title" content={actor.name} />
          <meta key="twitter:description" name="twitter:description" content={actor.shortDescription} />
        </Head>
        {data && !data.actor.isValidated && (containUser(data.actor.referents) || ((user as { role?: string })?.role === 'admin')) ? (
          <Alert severity="warning" sx={{ position: 'sticky', top: 0, zIndex: 1100, borderRadius: 0, justifyContent: 'center' }}>
            En attente de validation — l'acteur n'est pas encore visible sur le site.
          </Alert>
        ) : null}
        {/* DEBUG BANNER: Show when debug mode is active */}
        {(debugDisable || debugLog === 'true') && (
          <Alert severity="warning" sx={{ mb: 2, mx: 2, mt: 1 }}>
            <strong>🐛 DEBUG MODE:</strong> Disabled features: <code>{String(debugDisable || '(none)')}</code> | 
            <Link href={router.asPath.split('?')[0]} sx={{ ml: 1 }}>Disable debug</Link>
          </Alert>
        )}
        <Box>
          <Typography variant="h1" className={styles.hide}>
            {data && data.actor.name}
            -
            {data && data.actor.activity}
            -
            {data && data.actor.city}
            {data && showLaRochelleQuarter(data.actor.entries)}
            -
            {data && showCategory(data.actor.entries)}
          </Typography>
          {bannerUrl && (
            <Container
              className={styles.titleContainer}
              style={{
                backgroundImage: `url(${getImageUrl(bannerUrl)})`,
              }}
            />
          )}
          <Container className={styles.cardInfo}>
            <Grid container>
              {isMounted && isMobile && <ActorName name={data?.actor?.name} topImageSize="250px" headerDisplay="static" hasBannerUrl={bannerUrl !== null} />}
              <Grid item md={5} sm={10} className={styles.align}>
                <Grid container className={styles.infoPratiqueGrid}>
                  <div className={styles.printButton}>
                    <Tooltip title="Imprimer la page acteur">
                      <IconButton onClick={handlePrint} className={styles.printIcon} size="large">
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
                  </div>

                  {logo && logo.originalPicturePath && (
                    <div className={styles.image}>
                      <Image
                        loader={myLoader}
                        width={100}
                        height={100}
                        alt={logo.label || `Logo de ${actor.name}`}
                        style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        src={logo.originalPicturePath}
                      />
                    </div>
                  )}

                  <Grid container className={styles.item}>
                    <Grid item xs={3} className={styles.alignRight}>
                      <Image
                        src="/icons/location.svg"
                        alt="Localisation"
                        width={25}
                        height={25}
                        className={styles.icon}
                      />
                    </Grid>
                    <Grid item xs={8} className={styles.alignLeft}>
                      <div className={styles.infoLabel}>LOCALISATION </div>
                      <span className={styles.infoValue}>
                        {data && !data.actor.city && (
                          <span> Adresse manquante</span>
                        )}
                        {data && !data.actor.address && data.actor.city && (
                          <span>
                            {data && data.actor.city}
                          </span>
                        )}
                        {data && data.actor.address && data.actor.city && (
                          <span>
                            {`${data && data.actor.address} ${data && data.actor.city}`}
                          </span>
                        )}
                      </span>
                      {data
                        && entriesHasElementWithCode(
                          data.actor.entries,
                          'actor_location_action',
                        ) && (
                          <div className={styles.infoDiv}>
                            <div className={styles.infoLabel}>
                              TERRITOIRE D'ACTION
                            </div>
                            <span className={styles.infoValue}>
                              {data
                                && data.actor.entries.map(
                                  (entry) => entry
                                    && entry.collection
                                    && entry.collection.code
                                    === 'actor_location_action' && (
                                      <div key={entry.id}>
                                        <Typography
                                          variant="h6"
                                          className={styles.cardTitleCategories}
                                        >
                                          {` ${entry && entry.label}`}
                                        </Typography>
                                      </div>
                                    ),
                                )}
                            </span>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                  {data && data.actor.phone && (
                    <div className={styles.infoDiv}>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight}>
                          <Image
                            src="/icons/phone.svg"
                            width={25}
                            height={25}
                            alt="Téléphone"
                            className={styles.icon}
                          />
                        </Grid>
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>TELEPHONE</div>
                          <span className={styles.infoValue}>
                            {data && data.actor.phone}
                          </span>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {data && data.actor.email && (
                    <div className={styles.infoDiv}>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight}>
                          <Image
                            src="/icons/email.svg"
                            width={25}
                            height={25}
                            alt="Email"
                            className={styles.icon}
                          />
                        </Grid>
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>Email</div>
                          <span className={styles.infoValue}>
                            {data && data.actor.email}
                          </span>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {data && data.actor.website && actorWebsiteUrl && (
                    <div className={styles.infoDiv}>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight}>
                          <Image
                            src="/icons/web_site.svg"
                            width={25}
                            height={25}
                            alt="Site Web"
                            className={styles.icon}
                          />
                        </Grid>
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>
                            Site internet
                          </div>
                          <span className={styles.infoValue}>
                            <Link
                              href={actorWebsiteUrl}
                              target="_blank"
                              rel="noreferrer"
                            >
                              {data && data.actor.website}
                            </Link>
                          </span>
                        </Grid>
                      </Grid>
                    </div>
                  )}
                  {data && data.actor.socialNetworks && data.actor.socialNetworks.length > 0 && (
                    data.actor.socialNetworks.map((sn) => {
                      const socialNetworkUrl = urlWithHttpsdefault(sn.url);

                      return (
                        <Grid container className={styles.item} key={sn.id}>
                          <Grid item xs={3} className={styles.alignRight}>
                            {getSocialNetworkIcon(sn.type)}
                          </Grid>
                          <Grid item xs={8} className={styles.alignLeft}>
                            <div className={styles.infoLabel}>{getSocialNetworkLabel(sn.type)}</div>
                            <span className={styles.infoValue}>
                              {socialNetworkUrl ? (
                                <Link
                                  href={socialNetworkUrl}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  {sn.url}
                                </Link>
                              ) : sn.url}
                            </span>
                          </Grid>
                        </Grid>
                      );
                    })
                  )}
                  {data && data.actor.socialNetwork && actorSocialNetworkUrl && (!data.actor.socialNetworks || data.actor.socialNetworks.length === 0) && (
                    <Grid container className={styles.item}>
                      <Grid item xs={3} className={styles.alignRight}>
                        <Image
                          src="/icons/social.svg"
                          alt="Réseau social"
                          width={25}
                          height={25}
                          className={styles.icon}
                        />
                      </Grid>
                      <Grid item xs={8} className={styles.alignLeft}>
                        <div className={styles.infoLabel}>Réseau social</div>
                        <span className={styles.infoValue}>
                          <Link
                            href={actorSocialNetworkUrl}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {data && data.actor.socialNetwork}
                          </Link>
                        </span>
                      </Grid>
                    </Grid>
                  )}

                  {data
                    && data?.actor?.openingHours
                    && data?.actor?.openingHours.length !== 0 && (
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight}>
                          <Image
                            src="/icons/clock.svg"
                            width={25}
                            height={25}
                            alt="Horaire"
                            className={styles.icon}
                          />
                        </Grid>
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>{data?.actor?.entries?.some((entry) => entry.id === '108') ? 'Jour et horaire de distribution' : 'Horaire'}</div>
                          {data
                            && data?.actor?.openingHours.map((openingHour, idx) => {
                              return (
                                <span key={idx} className={styles.infoValue}>
                                  {openingHour.place}
                                  {openingHour.place && ' , '}
                                  {openingHour.days
                                    .filter((day) => day.selected)
                                    .map((day, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          {index != 0 && 'et '}
                                          {getDay(day.identifier)}
                                        </React.Fragment>
                                      );
                                    })}
                                  {openingHour.hours.map(
                                    (hourtab, indexhourtab) => {
                                      return (
                                        <React.Fragment key={indexhourtab}>
                                          {indexhourtab !== 0 && ' ; '}
                                          {hourtab.map((hour, index) => {
                                            return (
                                              <React.Fragment key={index}>
                                                {moment(hour).format('HH')}
                                                h
                                                {moment(hour).format('mm')}
                                                {index === 0 && ' - '}
                                              </React.Fragment>
                                            );
                                          })}
                                        </React.Fragment>
                                      );
                                    },
                                  )}
                                  <br />
                                </span>
                              );
                            })}
                        </Grid>
                      </Grid>
                    )}
                  {data?.actor?.entries?.some((entry) => entry.id === '108') && (
                    <>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight} />
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>
                            Contrats légumes
                          </div>
                          <span className={styles.infoValue}>
                            {data && data.actor.amapContratLegumes && <RichTextContent content={data.actor.amapContratLegumes} />}
                          </span>
                        </Grid>
                      </Grid>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight} />
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>
                            Autres contrats
                          </div>
                          <span className={styles.infoValue}>
                            {data && data.actor.amapAutresContrats && <RichTextContent content={data.actor.amapAutresContrats} />}
                          </span>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  {data?.actor?.entries?.some((entry) => entry.id === '109') && (
                    <>
                      <Grid container className={styles.item}>
                        <Grid item xs={3} className={styles.alignRight} />
                        <Grid item xs={8} className={styles.alignLeft}>
                          <div className={styles.infoLabel}>
                            Modes de distribution en circuit cours
                          </div>
                          <span className={styles.infoValue}>
                            {data && data.actor.fermeModeDistribution && <RichTextContent content={data.actor.fermeModeDistribution} />}
                          </span>
                        </Grid>
                      </Grid>
                    </>
                  )}
                  <Grid container className={styles.item}>
                    <Grid item xs={3} className={styles.alignRight}>
                      <Favorite actor={data?.actor} handleFavoriteChange={handleFavoriteChange} />
                    </Grid>
                    <Grid item xs={8} className={styles.alignLeft}>
                      <div className={styles.infoLabel}>
                        {!favorite ? ' Ajouter aux favoris' : ' Retirer des favoris'}
                      </div>
                      <span className={styles.infoValue} />
                    </Grid>
                  </Grid>
                  <Grid container className={styles.item}>
                    <Grid item xs={3} className={styles.alignRight}>
                      <Image
                        src="/icons/social.svg"
                        alt="Réseau social"
                        width={25}
                        height={25}
                        className={styles.icon}
                      />
                    </Grid>
                    <Grid item xs={8} className={styles.alignLeft}>
                      <div className={styles.infoLabel}>
                        Partager la page sur les réseaux
                      </div>
                      {!shouldDisable('share') && (
                      <span className={styles.infoValue}>
                        <FacebookShareButton url={`${currentLocationWindows}`}>
                          <FacebookShareIcon round size={32} className={styles.socialNetworkIcon} />
                        </FacebookShareButton>
                        <TwitterShareButton url={`${currentLocationWindows}`}>
                          <TwitterShareIcon round size={32} className={styles.socialNetworkIcon} />
                        </TwitterShareButton>
                        <WhatsappShareButton url={`${currentLocationWindows}`}>
                          <WhatsappShareIcon round size={32} className={styles.socialNetworkIcon} />
                        </WhatsappShareButton>
                        <TelegramShareButton url={`${currentLocationWindows}`}>
                          <TelegramShareIcon round size={32} className={styles.socialNetworkIcon} />
                        </TelegramShareButton>
                        <EmailShareButton url={`${currentLocationWindows}`}>
                          <EmailShareIcon round size={32} className={styles.socialNetworkIcon} />
                        </EmailShareButton>
                      </span>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={7} sm={10} className={styles.description}>
                {(!isMounted || !isMobile) && <ActorName name={data?.actor?.name} topImageSize="250px" headerDisplay="static" hasBannerUrl={bannerUrl !== null} />}
                <br />
                <br />
                {data?.actor?.entries?.some((entry) => entry.id === '108') && (
                  <>
                    {amapDescription}
                  </>
                )}
                <div>
                  {data && data.actor.description && <RichTextContent content={data.actor.description} />}
                </div>
                <div>
                  {data
                    && data.actor.entries.map(
                      (entry) => entry.parentEntry && (entry.enabled !== false)
                        && (entry.parentEntry?.collection?.code === 'category'
                          || entry.parentEntry?.parentEntry?.collection?.code === 'category') && (
                          <div key={entry.id}>
                            <Tooltip title={entry?.actorEntries?.linkDescription || ''} arrow>
                              <Typography
                                variant="h6"
                                className={styles.cardTitleCategories}
                              >
                                {entry.parentEntry?.parentEntry && (
                                  <>
                                    {entry.parentEntry.parentEntry.label}
                                    {' > '}
                                  </>
                                )}
                                {entry.parentEntry && entry.parentEntry.label}
                                {' > '}
                                {entry.icon && (
                                  <Image
                                    src={`/icons/${entry.icon}.svg`}
                                    alt="icon"
                                    width={30}
                                    height={25}
                                    className={styles.iconEntry}
                                  />
                                )}
                                {` ${entry && entry.label}`}
                              </Typography>
                            </Tooltip>
                          </div>
                        ),
                    )}
                </div>
                <br />
                {data
                  && entriesHasElementWithCode(
                    data.actor.entries.filter((entry) => entry.enabled),
                    'actor_status',
                  ) && (
                    <div className={styles.descriptionInfoDiv}>
                      <Image
                        src="/icons/status.svg"
                        alt="Status"
                        width={25}
                        height={25}
                        className={styles.icon}
                      />
                      <div className={styles.descriptionInfoLabel}>
                        {' '}
                        Statut :
                      </div>
                      <span className={styles.descriptionInfoValue}>
                        {data
                          && data.actor.entries.filter((entry) => entry.enabled).map(
                            (entry) => entry
                              && entry.collection
                              && entry.collection.code === 'actor_status' && (
                                <div key={entry.id}>
                                  <Tooltip title={entry?.actorEntries?.linkDescription || ''} arrow>
                                    <Typography
                                      variant="h6"
                                      className={styles.cardTitleCategories}
                                    >
                                      {`  ${entry && entry.label}`}
                                    </Typography>
                                  </Tooltip>
                                </div>
                              ),
                          )}
                      </span>
                    </div>
                  )}
                {data
                  && entriesHasElementWithCode(
                    data.actor.entries.filter((entry) => entry.enabled),
                    'public_target',
                  ) && (
                    <div className={styles.descriptionInfoDiv}>
                      <Image
                        src="/icons/public.svg"
                        alt="Public principal visé"
                        width={25}
                        height={25}
                        className={styles.icon}
                      />
                      <div className={styles.descriptionInfoLabel}>
                        Public principal visé
                      </div>
                      <span className={styles.descriptionInfoValue}>
                        {data
                          && data.actor.entries.filter((entry) => entry.enabled).map(
                            (entry) => entry
                              && entry.collection
                              && entry.collection.code === 'public_target' && (
                                <div key={entry.id}>
                                  <Tooltip title={entry?.actorEntries?.linkDescription || ''} arrow>
                                    <Typography
                                      variant="h6"
                                      className={styles.cardTitleCategories}
                                    >
                                      {` ${entry && entry.label}`}
                                    </Typography>
                                  </Tooltip>
                                </div>
                              ),
                          )}
                      </span>
                    </div>
                  )}
                <div />
                {data && data.actor.members.length == 0 && (
                  <>
                    <br />
                    <Typography variant="h3" className={styles.cardTitle}>
                      ACCES
                    </Typography>
                    <div className={styles.border} />
                    <br />
                    {!shouldDisable('maps') && data && data.actor && data.actor.lat && data.actor.lng && (
                      <div className={styles.map}>
                        <MapWithNoSSR
                          scrollWheelZoom={false}
                          position={[data.actor.lat, data.actor.lng]}
                          classMap={styles.mapContainer}
                        >
                          <MarkerWithNoSSR
                            event={data.actor}
                          />
                        </MapWithNoSSR>
                      </div>
                    )}
                  </>
                )}
              </Grid>
            </Grid>
            {data && data.actor.members && data.actor.members.length > 0 && (
              <div>
                <br />
                <Typography variant="h5" className={styles.cardTitle}>
                  Les acteurs du collectif
                </Typography>
                <div className={styles.border} />
                <br />
              </div>
            )}
            {actorMembersPictures.length > 0 && (
              <Slider
                {...settingsSliderImageActorMembers}
              >
                {data
                  && data.actor.members.map((actor) => {
                    return <CardSliderActor key={actor.id} actor={actor} />;
                  })}
              </Slider>
            )}

            {data && data.actor && data.actor.members.length > 0 && (
              <>
                {!shouldDisable('maps') && (
                <div className={styles.map}>
                  <MapWithNoSSR
                    scrollWheelZoom={false}
                    classMap={styles.mapContainer}
                  >
                    {data.actor?.members?.map((actor) => {
                      return (
                        <MarkerActorWithNoSSR key={actor.id} actor={actor} />
                      );
                    })}
                  </MapWithNoSSR>
                </div>
                )}
              </>
            )}

            <br />
            <br />
            {data && data.actor.hasVideoVouaaar && (
              <div className={styles.cardTitle} style={{ textAlign: 'center' }}>
                <Typography variant="h3" className={styles.cardTitle}>
                  Acteur à vouaaar !
                </Typography>
                <div className={styles.border} />
                <br />
                <video controls className={styles.video}>
                  <source src={'https://static.ouaaa-transition.fr/static/video/' + data.actor.id + '.mp4'} />
                </video>
              </div>
            )}
            {data && data.actor.volunteerDescription && (
              <div style={{ textAlign: 'center' }}>
                <br />
                <Typography variant="h3" className={styles.cardTitle}>
                  Recherche de bénévoles
                </Typography>
                <div className={styles.border} />
                <br />
                <div className={styles.volunteerSection}>
                  <Typography className={styles.volunteerTitle}>
                    {data && data.actor.name}
                    {' '}
                    recherche des bénévoles
                  </Typography>
                  <br />
                  <div className={styles.volunteerDescription}>
                    {data
                      && <RichTextContent content={data.actor.volunteerDescription} />}
                  </div>
                  <div>
                    {data
                      && (containUser(data.actor.volunteers)
                        || hasClickVolunteer) && (
                        <button
                          className={styles.buttonVolunteer}
                          onClick={removeVolunteerHandler}
                        >
                          Je ne souhaite plus être bénévole
                        </button>
                      )}
                    {data
                      && !containUser(data.actor.volunteers)
                      && !hasClickVolunteer && (
                        <button
                          className={styles.buttonVolunteer}
                          onClick={addVolunteerHandler}
                        >
                          Devenir bénévole
                        </button>
                      )}
                  </div>
                </div>
              </div>
            )}
            {data?.actor?.entries?.some((entry) => entry.id === '108') && (
              <div style={{ textAlign: 'center' }}>
                {data && data.actor.volunteerAction !== 'none' && (
                  <button
                    className={styles.buttonVolunteerAction}
                    onClick={() => {
                      if (data.actor.volunteerAction === 'externForm') {
                        window.open(data.actor.volunteerForm, '_blank');
                      }
                      if (data.actor.volunteerAction === 'email') {
                        setOpenModalRejoindreAMAP(true);
                      }
                    }}
                  >
                    Rejoindre l'AMAP
                  </button>
                )}
                <Modal
                  open={openModalRejoindreAMAP}
                  onClose={() => setOpenModalRejoindreAMAP(false)}
                  aria-labelledby="parent-modal-title"
                  aria-describedby="parent-modal-description"
                >
                  {bodyModalRejoindreAmap}
                </Modal>
                <br />
                <br />
              </div>
            )}
            {data && data.actor.pictures && data.actor.pictures.length > 0 && (
              <div>
                <Typography variant="h5" className={styles.cardTitle}>
                  PHOTOS
                </Typography>
                <div className={styles.border} />
                <br />
              </div>
            )}
            {actorPictures.length > 0 && (
              <Slider {...settingsSliderImage} className={styles.slider}>
                {data
                  && data.actor.pictures
                  && data.actor.pictures
                    .sort((a, b) => (a.position > b.position ? 1 : -1))
                    .map((picture) => (
                      <img
                        key={picture.id}
                        src={getImageUrl(picture.originalPicturePath) || undefined}
                        alt={picture.label || actor.name}
                        className={styles.img}
                        onClick={() => setOpenModalSlider(true)}
                      />
                    ))}
              </Slider>
            )}
            <Modal
              open={openModalSlider}
              onClose={() => setOpenModalSlider(false)}
              aria-labelledby="parent-modal-title"
              aria-describedby="parent-modal-description"
            >
              <Box sx={style}>
                <IconButton
                  aria-label="Close"
                  className={styles.closeButton}
                  onClick={() => setOpenModalSlider(false)}
                  size="large"
                >
                  <CloseIcon />
                </IconButton>
                <Slider {...sliderSettings} className={styles.slider}>
                  {data
                    && data.actor.pictures
                    && data.actor.pictures
                      .sort((a, b) => (a.position > b.position ? 1 : -1))
                      .map((picture) => (
                        <img
                          key={picture.id}
                          src={getImageUrl(picture.originalPicturePath) || undefined}
                          alt={picture.label || actor.name}
                          className={styles.imgModal}
                          onClick={() => setOpenModalSlider(false)}
                        />
                      ))}
                </Slider>
              </Box>
            </Modal>
            <div>
              <Typography variant="h5" className={styles.cardTitle}>
                LES ÉVÉNEMENTS DE
                {' '}
                {data && data?.actor?.name}
              </Typography>
              <div className={styles.border} />
            </div>
            <br />
            {!shouldDisable('calendar') && (
              <CalendarErrorBoundary>
                <Calendar
                  actor={data!.actor}
                  events={events}
                  withViewSwitcher={false}
                  withAddEvent={
                    (data && containUser(data.actor.referents) && data.actor.isValidated)
                    || ((user as { role?: string })?.role === 'admin')
                  }
                  className={styles.calendar}
                />
              </CalendarErrorBoundary>
            )}
            <br />
            {!shouldDisable('articles') && dataArticles && dataArticles.articles.length > 0 && (
              <>
                <div>
                  <Typography variant="h5" className={styles.cardTitle}>
                    LES ARTICLES DE
                    {' '}
                    {data && data?.actor?.name}
                  </Typography>
                  <div className={styles.border} />
                </div>
                <br />
                <Slider {...settingsSliderImageArticle} className={styles.articleCarroussel}>
                  {dataArticles &&
                    dataArticles.articles.map((article) => {
                      return <ArticleCard key={article.id} article={article} />;
                    })}
                </Slider>
              </>
            )}
            <br />
            {data?.actor?.id && <ActorPetitesAnnoncesSection actorId={data.actor.id} />}
            <br />
            {!shouldDisable('memberof') && data && data.actor.memberOf && data.actor.memberOf.length > 0 && (
              <div>
                <Typography variant="h5" className={styles.cardTitle}>
                  Fait partie du collectif
                </Typography>
                <div className={styles.border} />
                <br />
              </div>
            )}
            {!shouldDisable('memberof') && actorMemberOfPictures.length > 0 && (
              <Slider {...settingsSliderImageActorMemberOf}>
                {data
                  && data.actor.memberOf.map((actor) => {
                    return <CardSliderActor key={actor.id} actor={actor} />;
                  })}
              </Slider>
            )}
            <br />
            {!shouldDisable('partners') && data && actorPartnersPictures && actorPartnersPictures.length > 0 && (
              <div>
                <Typography variant="h5" className={styles.cardTitle}>
                  Acteurs partenaires :
                </Typography>
                <div className={styles.border} />
                <br />
              </div>
            )}
            {!shouldDisable('partners') && actorPartnersPictures.length > 0 && (
              <Slider {...settingsSliderImageActorPartners}>
                {data
                  && actorPartnersPictures.map((actor) => {
                    return <CardSliderActor key={actor.id} actor={actor} />;
                  })}
              </Slider>
            )}
            <br />
          </Container>
          {((data && containUser(data.actor.referents)) || ((user as { role?: string })?.role === 'admin')) && (
            <Link href={`/admin/actors/${data!.actor?.id}`}>
              <Fab
                className={styles.fab}
                aria-label="edit"
                sx={{
                  position: 'fixed',
                  bottom: 40,
                  right: 40,
                  zIndex: 1400,
                }}
              >
                <EditIcon />
              </Fab>
            </Link>
          )}
     {/**    <div style={{ display: 'none' }}>
            <ActorToPrint actor={data!.actor} ref={printRef} />
          </div>
          <div style={{ display: 'none' }}>
            <ActorGameToPrint actor={data!.actor} ref={printGameRef} />
          </div>
          */}  
        </Box>
      </>
    </AppLayout>
  );
};

export default withApollo()(Actor);

export const getServerSideProps: GetServerSideProps<ActorPageProps> = async (ctxt) => {
  const startDate = moment();

  const apiUri = process.env.API_INTERNAL_URI || process.env.NEXT_PUBLIC_API_URI;
  if (!apiUri) {
    console.error('Missing NEXT_PUBLIC_API_URI for actor SSR fetch');
    return { notFound: true };
  }

  let initialData: { data?: ActorData; errors?: Array<{ message: string }> };

  try {
    const res = await fetch(apiUri, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        operationName: 'actor',
        variables: {
          url: ctxt.params!.url,
        },
        query: GET_ACTOR_SSR,
      }),
    });

    if (!res.ok) {
      console.error(`Actor SSR fetch failed with status ${res.status} for ${ctxt.params!.url}`);
      return { notFound: true };
    }

    initialData = await res.json();
  } catch (error) {
    console.error(`Actor SSR fetch exception for ${ctxt.params!.url}`, error);
    return { notFound: true };
  }

  const endDate = moment();

  console.log(
    ` SSR actor id ${ctxt.params!.url} fetch in ${endDate.diff(startDate, 'seconds')} seconds`,
  );

  if (initialData.errors) {
    console.error(
      ` Error fetching actor id ${ctxt.params!.url} error message : ${initialData.errors[0].message}`,
    );
  }

  if (!initialData.data?.actor) {
    console.error(`Actor SSR returned no actor for ${ctxt.params!.url}`);
    return { notFound: true };
  }

  return {
    props: { initialData },
  };
};
